// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyCeIH534D-UlC0ZJXLbNKphASh3FPxIzGQ",
	authDomain: "ufind-system.firebaseapp.com",
	projectId: "ufind-system",
	storageBucket: "ufind-system.firebasestorage.app",
	messagingSenderId: "144357752801",
	appId: "1:144357752801:web:ceab3864f40feb29849ca0",
	measurementId: "G-V37LLVZXRB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };